import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const FIREBASE_APP_NAME = "feaslots-phone";
const RECAPTCHA_KEY = "feaRecaptchaVerifier";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDzQIPtFECdbt6HVjbr_zUIgLOOxn7zNjk",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sophiasweeps.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sophiasweeps",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sophiasweeps.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "989298038608",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:989298038608:web:2009a79811881b4290fe55",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-HY33BG13J6",
};

export function isFirebasePhoneConfigured() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId && firebaseConfig.appId);
}

function getFirebaseAuth() {
  const app = getApps().some((currentApp) => currentApp.name === FIREBASE_APP_NAME)
    ? getApp(FIREBASE_APP_NAME)
    : initializeApp(firebaseConfig, FIREBASE_APP_NAME);
  const auth = getAuth(app);
  auth.languageCode = "en";
  return auth;
}

export function resetFirebaseRecaptcha() {
  if (typeof window === "undefined") return;
  try {
    window[RECAPTCHA_KEY]?.clear?.();
  } catch {
    // Firebase can throw if the verifier is already cleared.
  }
  window[RECAPTCHA_KEY] = null;
}

function ensureRecaptcha(containerId) {
  const auth = getFirebaseAuth();
  if (window[RECAPTCHA_KEY]) return window[RECAPTCHA_KEY];
  window[RECAPTCHA_KEY] = new RecaptchaVerifier(auth, containerId, {
    size: "invisible",
  });
  return window[RECAPTCHA_KEY];
}

export function formatFirebasePhoneError(error) {
  const code = error?.code || "";
  const message = error?.message || "";
  if (code.includes("unauthorized-domain")) {
    return "Phone SMS is blocked because this domain is not authorized in Firebase. Add feaslots.com in Firebase Auth authorized domains.";
  }
  if (code.includes("too-many-requests") || code.includes("quota-exceeded")) {
    return "Too many SMS attempts. Wait a few minutes, then resend the code.";
  }
  if (code.includes("invalid-phone-number")) {
    return "Enter a valid 10-digit US phone number.";
  }
  if (code.includes("captcha-check-failed") || code.includes("missing-app-credential")) {
    return "Security check failed. Refresh the page and tap Send verification code again.";
  }
  if (code.includes("app-not-authorized")) {
    return "Phone SMS is blocked by Firebase app settings. Check the Firebase web app and authorized domain.";
  }
  if (code.includes("network-request-failed")) {
    return "Network blocked the SMS request. Turn off VPN/ad blocker and resend the code.";
  }
  return message || "SMS code could not be sent. Please try again.";
}

export async function sendFirebasePhoneCode(phoneNumber, containerId = "firebase-recaptcha-container") {
  if (!isFirebasePhoneConfigured()) {
    throw new Error("Firebase phone verification is not configured.");
  }
  const auth = getFirebaseAuth();
  const verifier = ensureRecaptcha(containerId);
  return signInWithPhoneNumber(auth, phoneNumber, verifier);
}
